import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { AuthService } from 'src/lib/auth/auth.service';
import { IBrand } from 'src/lib/repository/brand/brand.model';
import { MenuApi } from 'src/lib/repository/menu/menu.api';
import { IUserCard } from 'src/lib/repository/user-card/user-card.model';
import { IUserInfo } from 'src/lib/repository/user-info/user-info.model';
import { HomeScreenService } from 'src/lib/services/home-screen.service';
import { LanguageService } from 'src/lib/services/language.service';
import { BrandService } from '../../../lib/services/brand.service';
import { DialogService } from '../../services/dialog.service';
import { UiService } from '../../services/ui.service';
import { LoginComponent } from '../dialog/login/login.component';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
})
export class DrawerComponent implements OnInit {
  // 메뉴 마스터 목록
  readonly menuListNew = this.menuApi.menuList;

  // 가입 가능 여부
  canRegister = this.homeScreenService.homeScreen.userSignUp;

  /**
   * 로그인 여부
   */
  isLoggedIn?: boolean;

  /**
   * 브랜드 정보
   */
  brand?: IBrand;

  /**
   * 현재 언어
   */
  lang?: string;

  /**
   * 회원 정보
   */
  @Input()
  userInfo: IUserInfo | null = null;

  /**
   * 포인트 조회용 회원 카드
   */
  @Input()
  userCard: IUserCard | null = null;

  @Output()
  refreshInfoClick: EventEmitter<void> = new EventEmitter<void>();

  protected languageList = [
    { code: 'ja', name: '日本語' },
    { code: 'ko', name: '한국어' },
    { code: 'en', name: 'English' },
    { code: 'zh-CN', name: '简体中文' },
    { code: 'zh-TW', name: '繁體中文' },
    { code: 'vi', name: 'Tiếng Việt' },
    { code: 'ne', name: 'नेपाली भाषा' },
    { code: 'id', name: 'Bahasa Indonesia' },
    { code: 'tl', name: 'Filipino' },
    { code: 'th', name: 'ภาษาไทย' },
  ];

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialogService: DialogService,
    private menuApi: MenuApi,
    private uiService: UiService,
    private homeScreenService: HomeScreenService,
    private brandService: BrandService,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    this.brand = this.brandService.brand;

    this.setUserInfo();
    this.setDefaultLang();
  }

  /**
   * 브라우저 언어 값 확인 후 초기 표시 언어 설정
   */
  setDefaultLang(): void {
    const defaultLang = this.languageService.lang;
    this.lang = defaultLang;
  }

  onLogoutClick(): void {
    this.authService.logout('', true);
  }

  onLoginClick(): void {
    this.router.navigate(['requests']);
  }

  onRegisterClick(): void {
    if (this.canRegister) {
      this.router.navigate(['requests']);
    } else {
      // FIXME
      // this.dialogService.alert('ALERT.Req_Register_Travel_Agency').subscribe();
    }
    // else if (this.cantRegisterMsg) {
    //   this.dialogService.alert(this.cantRegisterMsg);
    // }
  }

  /**
   * 회원 정보 갱신
   */
  onRefreshInfoButtonClick(): void {
    this.refreshInfoClick.emit();
  }

  /**
   * 언어 변경 메뉴 클릭
   */
  onChangeLanguage(lang: string): void {
    this.languageService.changeLang(lang);
  }

  isEtcBrand(): boolean {
    return this.brand?.brandType === 'ETC';
  }

  /**
   * 크기별 메뉴 표시 여부
   */
  isMenuVisibleByBreakpoint(breakpoint?: string): boolean {
    return this.uiService.isVisibleByBreakpoint(breakpoint);
  }

  /**
   * 지원 언어 여부
   */
  isSupportedLanguage(lang: string): boolean {
    return this.languageService.languageSet.has(lang);
  }

  /**
   * 회원 정보 설정
   */
  private setUserInfo(): void {
    if (this.authService.account) {
      this.isLoggedIn =
        this.authService.account?.userInfo?.certType !== 'GUEST';
    }

    this.authService.loginSubject$
      .asObservable()
      .pipe(
        tap(() => {
          this.isLoggedIn =
            this.authService.account != null &&
            this.authService.account?.userInfo?.certType !== 'GUEST';
        }),
      )
      .subscribe();
  }

  /**
   * boolean을 반환하는 로그인 모달
   *
   * 로그인 했으면 무조건 true
   */
  private login(): Observable<boolean> {
    if (this.authService.account) {
      return of(true);
    }

    return this.dialogService.open(LoginComponent).onDialogClosed;
  }
}
